import React from 'react';
import { useTranslation } from 'react-i18next';
import { getValidLink } from '../../../../utilities/validContactInformation';

const ContactInfoBox = ({
  departmentName,
  email,
  phoneNumber,
  contactPerson,
  showEmptyValues,
}) => {
  const { t: translator } = useTranslation();

  const renderEmailAsLink = !!getValidLink(showEmptyValues)(email);

  return (
    <div id="info-box-contact-information">
      <h3>{translator('global.contactInformation')}</h3>
      <hr className="create-hearing-header-hr" />
      {(departmentName || showEmptyValues) && (
        <div className="create-hearing-info-text-field" id="department-name">
          <p className="title">
            {translator('hearingProperties.departmentName')}{' '}
          </p>
          <p className="value">{departmentName || '-'}</p>
        </div>
      )}
      {(email || showEmptyValues) && !renderEmailAsLink && (
        <div className="create-hearing-info-text-field" id="e‐mail">
          <p className="title">{translator('hearingProperties.email')} </p>
          <p className="value">{email || '-'}</p>
        </div>
      )}
      {(email || showEmptyValues) && renderEmailAsLink && (
        <div className="create-hearing-info-text-field" id="e‐mail-as-link">
          <p className="title">{translator('hearingProperties.email')} </p>
          <a className="value" href={email} target="_blank" rel="noreferrer">
            {translator('global.writeMessage')}
          </a>
        </div>
      )}
      {(phoneNumber || showEmptyValues) && (
        <div className="create-hearing-info-text-field" id="telephone-number">
          <p className="title">{translator('hearingProperties.telephone')} </p>
          <p className="value">{phoneNumber || '-'}</p>
        </div>
      )}
      {(contactPerson || showEmptyValues) && (
        <div className="create-hearing-info-text-field" id="contact-person">
          <p className="title">
            {translator('hearingProperties.contactPerson')}{' '}
          </p>
          <p className="value">{contactPerson || '-'}</p>
        </div>
      )}
    </div>
  );
};

export { ContactInfoBox };
